/* eslint-disable */
import { makeStyles } from '@rentacenter/racstrap';
import React from 'react';
import clsx from 'clsx';
import { RACCOLOR } from '@rentacenter/racstrap';
import { useStoreDetails } from '../../../context/Store/StoreProvider';
import { TranslatedCategory } from '../../../utils/TextTempTranslation';

interface CategoryListProps {
  categories: string[];
  selectedCategory: string;
  onClick: (selected: string) => void;
}
const useStyles = makeStyles((theme: any) => ({
  categoryListContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: RACCOLOR.BRILLIANCE,
  },
  categoryListItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: theme.typography.pxToRem(315),
    overflowY: 'auto',
  },
  categoryListTitle: {
    ...theme.typography.h5,
    paddingLeft: '1rem !important',
    margin: '1rem 0 !important',
    color: RACCOLOR.POMPEII_ASH,
  },
  categoryListItem: {
    padding: '.5rem 1rem',
    cursor: 'pointer',
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },
  active: {
    color: RACCOLOR.BLUE_CRAYOLA,
    backgroundColor: RACCOLOR.HOARFROST,
  },
}));

export const CategoryList = ({
  categories,
  selectedCategory,
  onClick,
}: CategoryListProps) => {
  const classes = useStyles();
  const language = window.sessionStorage.getItem('language') || 'en';
  const translate = (english: string, spanish: string) => {
    if (language === 'es-MX' || language === 'es-US') {
      return spanish;
    } else {
      return english;
    }
  };
  return (
    <div className={classes.categoryListContainer}>
      <span className={classes.categoryListTitle}>
        {translate('CATEGORY', 'CATEGORÍA')}
      </span>
      <div className={classes.categoryListItemContainer}>
        {categories.map((category) => (
          <span
            onClick={() => onClick(category)}
            className={clsx(
              classes.categoryListItem,
              selectedCategory === category && classes.active
            )}
            key={category}
          >
            {translate(category, TranslatedCategory[category])}
          </span>
        ))}
      </div>
    </div>
  );
};
